
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitopanchganicab() {



    const cardData =
    {
        keyword: 'Mumbai to Panchgani Cab',
        heading: 'Skyline Cabs: Mumbai to Panchgani Cab',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Mumbai to Panchgani Cab services for a refreshing hill station getaway. Whether you are heading to Panchgani for its scenic landscapes, strawberry farms, or a peaceful retreat from the city, our well-maintained vehicles and courteous drivers ensure a smooth and enjoyable journey. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Mumbai to Panchgani cab with Skyline Cabs today and experience a hassle-free ride to one of Maharashtra’s most charming hill towns!',

        top: 'Top Places to Visit in Panchgani with Skyline Cabs',

"topPlaces": [
    {
        "title": "Table Land",
        "description": "Asia’s second-highest volcanic plateau, Table Land is a vast stretch of laterite rock offering panoramic views of the surrounding hills and valleys. It's a popular spot for horse riding, paragliding, and enjoying sunsets, and also features several food stalls."
    },
    {
        "title": "Parsi Point",
        "description": "Parsi Point offers stunning views of the Krishna Valley and the Dhom Dam. Named after the Parsi community that frequented the area, this viewpoint is a favorite picnic spot with ample seating and scenic photo opportunities."
    },
    {
        "title": "Sydney Point",
        "description": "Located on a hillock facing the Krishna Valley, Sydney Point is known for its breathtaking views of the Dhom Dam, Kamalgad Fort, and Wai town. It’s a great place to catch a sunrise or just soak in the beauty of Panchgani."
    },
    {
        "title": "Mapro Garden",
        "description": "A short drive from Panchgani, Mapro Garden is a delightful spot for families and food lovers. It features strawberry farms, a chocolate factory, a café offering fresh berry treats, and a retail outlet selling jams, syrups, and more."
    },
    {
        "title": "Devil’s Kitchen",
        "description": "Steeped in mythology, Devil’s Kitchen is believed to be the place where the Pandavas stayed during their exile. This mysterious site is surrounded by lush greenery and is ideal for a quiet, reflective walk."
    },
    {
        "title": "Rajpuri Caves",
        "description": "Located a few kilometers from Panchgani, the Rajpuri Caves are ancient rock-cut caves associated with religious legends. Surrounded by holy kunds (ponds), the site is considered sacred and offers a tranquil ambiance for visitors."
    },
    {
        "title": "Harrison’s Folly",
        "description": "An open, flat land surrounded by deep valleys on all sides, Harrison’s Folly is a lesser-known viewpoint but offers mesmerizing views and a peaceful environment. It's perfect for those looking to escape the crowds."
    },
    {
        "title": "Dhom Dam",
        "description": "Visible from many viewpoints in Panchgani, Dhom Dam is a scenic spot offering boating activities and picnic options. The calm waters and surrounding hills create a picture-perfect landscape."
    },
    {
        "title": "Lingmala Waterfall",
        "description": "Located en route to Mahabaleshwar, Lingmala Waterfall is a spectacular cascade especially during the monsoon season. The main waterfall plunges from a height of over 500 feet and is surrounded by lush green forest."
    },
    {
        "title": "Bhilar Village – Book Village of India",
        "description": "Bhilar is India’s first ‘Book Village,’ where homes and public places have been transformed into open libraries. It promotes reading and tourism, offering a unique cultural experience for bibliophiles and curious travelers alike."
    }
],

"services": [
    {
      "name": "Mumbai to Panchgani Cab",
      "description": "Skyline Cabs offers a comfortable cab service from Mumbai to Panchgani. Enjoy a relaxing ride through scenic routes with our professional drivers."
    },
    {
      "name": "Panchgani Taxi Service",
      "description": "Choose Skyline Cabs for a reliable and convenient taxi service to Panchgani. Whether it's for a getaway or a quick visit, we've got your travel needs covered."
    },
    {
      "name": "Mumbai to Panchgani One Way Cab",
      "description": "Book a one-way cab from Mumbai to Panchgani with Skyline Cabs. Ideal for travelers needing a single-trip journey without the return ride."
    },
    {
      "name": "Mumbai to Panchgani Taxi Fare",
      "description": "Get competitive taxi fares for your journey from Mumbai to Panchgani with Skyline Cabs. Pricing depends on vehicle type and trip details."
    },
    {
      "name": "Taxi from Mumbai to Panchgani",
      "description": "Travel safely and comfortably with Skyline Cabs from Mumbai to Panchgani. Our experienced drivers ensure timely and secure travel."
    },
    {
      "name": "Panchgani Trip Taxi Booking",
      "description": "Plan your Panchgani trip with Skyline Cabs. Easy booking, great service, and a pleasant ride await you on this scenic route."
    }
  ],
  "tableData": [
    ["Mumbai to Panchgani Cab", "Panchgani Taxi Service"],
    ["Mumbai to Panchgani One Way Cab", "Mumbai to Panchgani Taxi Fare"],
    ["Taxi from Mumbai to Panchgani", "Panchgani Trip Taxi Booking"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Reliable Mumbai to Panchgani Cab Service",
      "WhyChoosedescription": "Travel from Mumbai to Panchgani in comfort and style with our reliable cab service. Whether you're heading for a peaceful getaway or a family trip, we ensure a smooth journey."
    },
    {
      "WhyChooseheading": "Comfortable and Scenic Ride",
      "WhyChoosedescription": "Our cabs are perfect for the scenic drive to Panchgani, offering plush seating and a comfortable experience, so you can enjoy the journey through the beautiful hills."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer affordable and transparent pricing for your Mumbai to Panchgani trip. No hidden charges—just straightforward, budget-friendly rates."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Drivers",
      "WhyChoosedescription": "Our experienced drivers are familiar with the Mumbai to Panchgani route and are dedicated to providing a safe, friendly, and efficient ride."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "All our vehicles are thoroughly cleaned and sanitized to ensure your safety, hygiene, and comfort during your Mumbai to Panchgani trip."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Whether you're planning a one-way journey or a round trip, we offer flexible travel options to suit your schedule and travel plans to Panchgani."
    },
    {
      "WhyChooseheading": "24/7 Customer Support and Easy Booking",
      "WhyChoosedescription": "Book your Mumbai to Panchgani cab at any time through our easy online booking system or by contacting our 24/7 customer support team for assistance."
    },
    {
      "WhyChooseheading": "Ideal for Family, Friends, or Solo Travelers",
      "WhyChoosedescription": "Whether you're traveling with family, friends, or alone, our cabs provide the perfect blend of comfort and reliability for your trip to Panchgani."
    }
  ]
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Panchgani with Skyline Cabs?',
            answer:
                'Booking a cab from Mumbai to Panchgani is simple and convenient. You can book through our website, mobile app, or by calling our customer support. Just enter your pickup location, travel date, and select your preferred vehicle for the journey.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Panchgani?',
            answer:
                'The distance from Mumbai to Panchgani is approximately 250 km. The travel time usually ranges from 5 to 6 hours, depending on traffic and road conditions. Our drivers take the best routes to ensure a smooth and timely journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Panchgani trip?',
            answer:
                'We offer a variety of vehicles for the Mumbai to Panchgani journey, including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups, we provide Tempo Travellers and luxury coaches.',
        },
        {
            id: 4,
            question: 'Are your cab fares for Mumbai to Panchgani fixed?',
            answer:
                'Yes, we provide fixed and transparent pricing for your Mumbai to Panchgani journey. The fare includes vehicle rental, driver charges, fuel, tolls, taxes, and any applicable service fees. You will know the total fare before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai to Panchgani?',
            answer:
                'Yes, we offer one-way cab options for your convenience. You can choose a round-trip service if you plan to return to Mumbai at a later time.',
        },
        {
            id: 6,
            question: 'What is the best time to travel from Mumbai to Panchgani?',
            answer:
                'The best time to travel to Panchgani is from October to March when the weather is pleasant and cool. However, Skyline Cabs operates year-round, and our drivers are experienced in handling different weather conditions.',
        },
        {
            id: 7,
            question: 'Are stopovers allowed during the Mumbai to Panchgani journey?',
            answer:
                'Yes, we allow short stopovers for refreshments, meals, or sightseeing along the way. Let the driver know if you wish to take a break or explore any specific spots on the route.',
        },
        {
            id: 8,
            question: 'What payment options are available for the Mumbai to Panchgani cab?',
            answer:
                'We accept various payment methods, including UPI, credit/debit cards, net banking, and cash payments after the trip. All online payments are secure and processed through trusted gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai to Panchgani cab booking?',
            answer:
                'Yes, you can modify or cancel your booking easily via our website, mobile app, or by contacting customer support. We offer flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai to Panchgani trip?',
            answer:
                'Skyline Cabs offers a comfortable, safe, and reliable journey to Panchgani. We provide well-maintained vehicles, experienced drivers, and transparent pricing. Our excellent customer service ensures that your trip is enjoyable and hassle-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Anil Khatri",
            rating: 5,
            review: "Our trip from Mumbai to Panchgani with Skyline Cabs was fantastic! The driver was very professional, and the car was clean and comfortable. The scenic drive was beautiful, and we had a great time. Highly recommend it!"
        },
        {
            name: "Miss. Neha Sharma",
            rating: 4,
            review: "The journey from Mumbai to Panchgani was smooth and comfortable. The driver was polite, and the car was spacious. We enjoyed the trip, but we would have preferred a bit more time for sightseeing. Overall, a pleasant experience!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   
      
      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Panchgani Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-panchgani-cab.jpg",
  "description": "Book Mumbai to Panchgani cab with Skyline Cabs for a relaxing hill station escape. Choose from AC sedans, SUVs, or luxury cabs with experienced drivers — ideal for families, couples, and weekend trips with fixed pricing and 24/7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8371"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-panchgani-cab"
  }
};


      

    return (
        <div>
<Helmet>
  <title>Mumbai to Panchgani Cab | AC Taxi Booking Hill Station Trip | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Panchgani cab with Skyline Cabs for a relaxing hill station escape. Choose from AC sedans, SUVs, or luxury cabs with experienced drivers — ideal for families, couples, and weekend trips with fixed pricing and 24/7 availability." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Panchgani Cab, AC Cab Panchgani from Mumbai, Panchgani Hill Station Taxi, Mumbai to Panchgani Sedan, SUV Cab Panchgani, Online Cab Booking Panchgani, Skyline Cabs Panchgani Tour, Mumbai to Panchgani One Way Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/87.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopanchganicab;